// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1067":"2ec41542","1850":"6e9faf02","2073":"40010928","3582":"2ec41542","4858":"de1843fa","6066":"2ec41542","7371":"91def833","7571":"de1843fa","9759":"6e9faf02"}[chunkId] + ".chunk.css";
};